var _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSdgIconDe03(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "svg2",
    xmlSpace: "preserve",
    width: 566.93335,
    height: 566.93335,
    viewBox: "0 0 566.93335 566.93335",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g8",
    transform: "matrix(1.3333333,0,0,-1.3333333,0,566.93333)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g10",
    transform: "scale(0.1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 4253.01,-1.07813 H -1.01172 V 4253.07 H 4253.01 V -1.07813",
    style: {
      fill: "#339d3b",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path12"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 606.051,3027.26 c 145.531,0 208.754,77.21 208.754,196.09 v 126.49 c 0,78.43 -34.157,129.07 -106.258,145.5 59.453,18.95 98.672,67.05 98.672,139.15 v 74.65 c 0,121.44 -58.196,196.08 -191.024,196.08 -149.324,0 -201.187,-88.52 -201.187,-215.04 v -75.89 h 131.558 v 87.27 c 0,53.13 16.497,83.47 62.039,83.47 45.567,0 61.938,-30.34 61.938,-77.15 v -92.36 c 0,-45.55 -30.336,-69.54 -77.113,-69.54 h -54.453 v -110.13 h 60.777 c 50.574,0 70.789,-23.99 70.789,-69.55 v -141.7 c 0,-45.5 -20.215,-77.19 -64.492,-77.19 -49.336,0 -67.074,32.93 -67.074,83.52 v 122.71 H 407.492 v -112.57 c 0,-130.33 51.817,-213.81 198.559,-213.81",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path14"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 3554.87,1594.36 c 0,119.71 -76.81,216.75 -193.14,216.75 -58.17,0 -128.34,-63.7 -166.44,-102.88 -38.11,39.23 -103.63,102.98 -161.83,102.98 -116.33,0 -197.85,-97.06 -197.85,-216.79 0,-59.86 23.57,-114.04 61.72,-153.29 v 0 l 298.21,-298.75 297.81,298.41 -0.24,0.22 c 38.16,39.24 61.76,93.47 61.76,153.35",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path16"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 2285.24,654.641 c -1.01,0 -2.01,0.031 -3.05,0.089 -22.66,1.379 -41.38,18.2 -45.23,40.602 l -151.47,882.198 -229.46,-425.42 c -10.04,-18.64 -31.03,-28.67 -51.66,-24.97 -20.83,3.71 -36.89,20.34 -39.91,41.26 l -97.41,680.84 -178.21,-400.3 c -7.88,-17.66 -25.41,-29.05 -44.74,-29.05 H 751.426 c -27.055,0 -48.973,21.93 -48.973,48.97 0,27.04 21.918,48.97 48.973,48.97 h 660.864 l 234.42,526.54 c 8.88,19.92 29.87,31.56 51.5,28.58 21.61,-3.03 38.63,-19.96 41.72,-41.57 l 100.43,-702.03 226.29,419.55 c 9.91,18.44 30.39,28.51 51.04,25.09 20.6,-3.38 36.79,-19.46 40.32,-40.05 l 140.27,-817.049 511.25,1698.239 c 5.84,19.34 22.93,33.12 43.03,34.7 20.2,1.5 39.22,-9.35 47.97,-27.54 l 269.02,-557.68 c 11.74,-24.36 1.52,-53.63 -22.83,-65.37 -24.34,-11.76 -53.64,-1.54 -65.39,22.82 L 2867.03,2466.35 2332.1,689.488 c -6.25,-20.797 -25.39,-34.847 -46.86,-34.847",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path18"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 1275.64,3738.11 h 85.85 v -191.84 h -43.46 v 39.21 c -7.95,-27.02 -24.9,-43.45 -57.76,-43.45 -51.93,0 -75.78,41.33 -75.78,96.98 v 173.81 c 0,56.18 27.03,96.98 90.62,96.98 66.77,0 86.38,-37.09 86.38,-90.09 v -31.79 h -55.12 v 36.56 c 0,22.26 -8.47,34.98 -30.2,34.98 -21.73,0 -31.26,-15.37 -31.26,-37.09 v -192.91 c 0,-21.72 9,-37.09 29.68,-37.09 19.6,0 29.66,11.13 29.66,34.45 v 63.59 h -28.61 v 47.7",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 1393.31,3905.56 h 144.14 v -49.28 h -83.73 v -102.8 h 59.88 v -48.76 h -59.88 v -109.17 h 83.73 v -49.28 h -144.14 v 359.29",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path22"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 1561.31,3623.64 v 48.22 h 56.18 v -49.29 c 0,-20.13 9.01,-31.78 29.67,-31.78 19.09,0 27.56,12.71 27.56,31.78 v 13.79 c 0,20.66 -8.47,33.39 -27.02,50.87 l -35.51,35.51 c -34.44,33.91 -50.34,54.58 -50.34,95.92 v 12.18 c 0,44.52 25.97,78.96 84.79,78.96 60.41,0 84.25,-29.67 84.25,-81.6 v -29.15 h -55.1 v 31.27 c 0,20.66 -9.54,30.73 -28.63,30.73 -16.95,0 -28.61,-9.54 -28.61,-29.67 v -7.43 c 0,-20.13 11.13,-31.79 28.61,-48.75 l 38.7,-38.16 c 32.85,-33.38 48.75,-53.52 48.75,-93.26 v -17.49 c 0,-49.29 -26.5,-84.26 -87.97,-84.26 -61.48,0 -85.33,34.44 -85.33,81.61",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 1939.19,3905.56 v -271.85 c 0,-55.65 -23.85,-91.68 -85.33,-91.68 -63.59,0 -90.08,36.03 -90.08,91.68 v 271.85 h 60.41 v -277.68 c 0,-21.2 8.47,-35.51 29.67,-35.51 21.2,0 29.68,14.31 29.68,35.51 v 277.68 h 55.65",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path26"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 2021.88,3772.02 V 3546.27 H 1971 v 359.29 h 59.36 l 65.18,-206.14 v 206.14 h 50.34 v -359.29 h -52.99 l -71.01,225.75",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path28"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 2263.55,3595.55 c 24.9,0 34.44,14.84 34.44,36.57 v 188.13 c 0,21.19 -9.54,36.03 -34.44,36.03 h -25.44 v -260.73 z m 94.85,213.57 v -166.4 c 0,-55.12 -22.78,-96.45 -87.43,-96.45 h -93.27 v 359.29 h 93.27 c 64.65,0 87.43,-40.8 87.43,-96.44",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path30"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 2508.93,3704.72 h -58.29 v -158.45 h -60.41 v 359.29 h 60.41 v -152.08 h 58.29 v 152.08 h 60.95 v -359.29 h -60.95 v 158.45",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path32"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 2601.7,3905.56 h 144.14 v -49.28 h -83.73 v -102.8 h 59.88 v -48.76 h -59.88 v -109.17 h 83.73 v -49.28 H 2601.7 v 359.29",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path34"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 2775.53,3905.56 h 60.41 v -359.29 h -60.41 v 359.29",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path36"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 2861.38,3905.56 h 160.58 v -49.28 h -49.82 v -310.01 h -60.94 v 310.01 h -49.82 v 49.28",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path38"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 3275.82,3905.56 v -271.85 c 0,-55.65 -23.85,-91.68 -85.32,-91.68 -63.59,0 -90.09,36.03 -90.09,91.68 v 271.85 h 60.42 v -277.68 c 0,-21.2 8.47,-35.51 29.67,-35.51 21.2,0 29.67,14.31 29.67,35.51 v 277.68 h 55.65",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path40"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 3358.51,3772.02 v -225.75 h -50.88 v 359.29 h 59.36 l 65.18,-206.14 v 206.14 h 50.35 v -359.29 h -53 l -71.01,225.75",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path42"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 3600.18,3595.55 c 24.91,0 34.45,14.84 34.45,36.57 v 188.13 c 0,21.19 -9.54,36.03 -34.45,36.03 h -25.43 v -260.73 z m 94.86,213.57 v -166.4 c 0,-55.12 -22.78,-96.45 -87.44,-96.45 h -93.27 v 359.29 h 93.27 c 64.66,0 87.44,-40.8 87.44,-96.44",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 1314.86,3268.31 -33.92,-222.04 h -56.71 l -48.22,359.29 h 58.29 l 28.09,-227.87 h 0.54 l 30.2,227.87 h 49.29 l 33.38,-227.87 h 0.53 l 27.55,227.87 h 50.88 l -46.64,-359.29 h -57.23 l -35.5,222.04 h -0.53",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path46"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 1595.22,3129.47 v 192.9 c 0,21.72 -9.54,37.09 -31.26,37.09 -21.2,0 -30.74,-15.37 -30.74,-37.09 v -192.9 c 0,-21.73 9.54,-37.1 30.74,-37.1 21.72,0 31.26,15.37 31.26,37.1 z m -122.41,9.54 v 173.81 c 0,56.18 27.56,96.98 91.15,96.98 64.12,0 91.68,-40.8 91.68,-96.98 v -173.81 c 0,-55.65 -27.56,-96.98 -91.68,-96.98 -63.59,0 -91.15,41.33 -91.15,96.98",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path48"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 1806.16,3204.72 h -58.29 v -158.45 h -60.41 v 359.29 h 60.41 v -152.08 h 58.29 v 152.08 h 60.95 v -359.29 h -60.95 v 158.45",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path50"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 1898.92,3405.56 h 60.41 v -310.01 h 72.07 v -49.28 h -132.48 v 359.29",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path52"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 2056.32,3405.56 h 144.15 v -49.28 h -83.73 v -102.8 h 59.89 v -48.76 h -59.89 v -109.17 h 83.73 v -49.28 h -144.15 v 359.29",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path54"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 2290.57,3356.28 v -111.81 h 20.14 c 20.67,0 29.68,10.59 29.68,29.67 v 53 c 0,19.6 -9.01,29.14 -29.68,29.14 z m 0,-145.2 v -164.81 h -60.41 v 359.29 h 87.97 c 60.95,0 83.2,-30.2 83.2,-80.55 v -46.1 c 0,-38.69 -13.78,-61.47 -48.22,-69.42 l 57.76,-163.22 h -63.59 l -56.71,164.81",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 2522.71,3238.1 h 85.85 v -191.83 h -43.46 v 39.21 c -7.95,-27.02 -24.9,-43.45 -57.76,-43.45 -51.93,0 -75.78,41.33 -75.78,96.98 v 173.81 c 0,56.18 27.03,96.98 90.62,96.98 66.77,0 86.38,-37.09 86.38,-90.09 v -31.79 h -55.12 v 36.56 c 0,22.26 -8.47,34.98 -30.2,34.98 -21.73,0 -31.26,-15.37 -31.26,-37.09 v -192.9 c 0,-21.73 9,-37.1 29.68,-37.1 19.6,0 29.66,11.13 29.66,34.45 v 63.59 h -28.61 v 47.69",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path58"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 2640.38,3405.56 h 144.14 v -49.28 h -83.73 v -102.8 h 59.88 v -48.76 h -59.88 v -109.17 h 83.73 v -49.28 h -144.14 v 359.29",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path60"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 2932.92,3204.72 h -58.3 v -158.45 h -60.41 v 359.29 h 60.41 v -152.08 h 58.3 v 152.08 h 60.94 v -359.29 h -60.94 v 158.45",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path62"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 3025.68,3405.56 h 144.14 v -49.28 h -83.73 v -102.8 h 59.88 v -48.76 h -59.88 v -109.17 h 83.73 v -49.28 h -144.14 v 359.29",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 3250.39,3272.02 v -225.75 h -50.88 v 359.29 h 59.35 l 65.19,-206.14 v 206.14 h 50.34 v -359.29 h -53 l -71,225.75",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path66"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSdgIconDe03);
export default __webpack_public_path__ + "static/media/SDG-icon-DE-03.e6d2f021e3eec27ff0193d4d3a307995.svg";
export { ForwardRef as ReactComponent };